import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";
export interface Behaviour {
  key: string;
  comment: string;
}

//---- Automatically generated, don't update this part ----

/**
 * This journal event describes the patient's lifestyle.
 */
export default class LifestyleDeclaredJournalEvent extends JournalEvent {
  static override type = "lifestyle-declared-journal-event";

  /**
   * an array containing several behaviours
   */
  @attr({
    defaultValue() {
      return [];
    }
  })
  declare behaviours: any[];

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.lifestyle-declared-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "lifestyleDeclaredJournalEvent"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "lifestyle-declared-journal-event": LifestyleDeclaredJournalEvent;
  }
}
